import {
    handleRemoveObservationWorkflowClick,
    handleUnRemoveObservationWorkflowClick
} from '../../lib/schoolAdmin/teacherGoaTabProgress.js';

const performanceByToolIds = [
    'schoolYear', 'schoolId', 'toolLabel'
];

const $schoolIdSelect = $('#schoolId');
const $removeObservationWorkflowItemForm = $('.remove_observation_workflow_item_form');
const $unRemoveObservationWorkflowItemForm = $('.unremove_observation_workflow_item_form');

performanceByToolIds.forEach((id) => {
    $('#' + id).selectize();
});


//$schoolIdSelect.change((e) => e.target.form.submit());
$removeObservationWorkflowItemForm.on("click", ".button", handleRemoveObservationWorkflowClick);
$unRemoveObservationWorkflowItemForm.on("click", ".button", handleUnRemoveObservationWorkflowClick);

